import React from "react";

import { SmallCheckbox } from "app/components/ui/checkbox1";
import { Label } from "app/components/ui/label";
import { Input } from "app/components/ui/input";

export const CustomerVerification = () => {
  return (
    <React.Fragment>
      <div className="bg-[#FFFDF4] p-2.5 sm:p-3 lg:p-3.5 rounded-lg md:rounded-xl mb-4 sm:mb-5 lg:mb-6">
        <h6 className="font-mobile text-black text-[0.785rem] sm:text-[0.825rem] lg:text-sm font-extrabold leading-5 sm:leading-6 lg:leading-7 tracking-[-0.02625rem]">
          Instructions for customer
        </h6>
        <p className="text-black text-[0.72rem] sm:text-xs font-normal leading-4 sm:leading-[1.1175rem]">
          As part of our commitment to customer privacy and account security, we
          require a valid, unexpired, government-issued photo ID to process your
          request. Please send the ID to processing@vlemobile.com with the
          subject line: 'SIM UNLOCK REQUEST AH0619254'.
        </p>
      </div>
      <div className="mb-3.5 sm:mb-[1.125rem] lg:mb-[1.625rem]">
        <h6 className="font-mobile text-black text-[0.785rem] sm:text-[0.825rem] lg:text-sm font-extrabold leading-5 sm:leading-6 lg:leading-7 tracking-[-0.02625rem] mb-1 sm:mb-1.5 lg:mb-2">
          Upload ID
        </h6>
        <div className="relative flex flex-col justify-center items-center h-[11.75rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-3 lg:py-4 border border-[#E9EAEB] rounded-lg md:rounded-xl">
          <div className="size-8 sm:size-10 p-1.5 sm:p-2 lg:p-2.5 border border-[#D5D7DA] rounded-lg shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),0px_1px_2px_0px_rgba(10,13,18,0.05)] mb-1.5 sm:mb-2 lg:mb-3">
            <img
              src="/assets/upload-cloud.svg"
              alt="Upload"
              className="size-full"
            />
          </div>
          <div className="space-y-0.5 sm:space-y-1">
            <p className="text-center text-[#535862] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5">
              <span className="text-[#FE4D01] font-semibold">
                Click to upload
              </span>{" "}
              or drag and drop
            </p>
            <p className="text-center text-[#535862] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5">
              PNG, JPEG or PDF (max. 2MB)
            </p>
          </div>
          <Input
            type="file"
            className="absolute inset-0 w-full h-full opacity-0"
            name="fileUpload"
            accept=".png,.pdf,.jpeg"
          />
        </div>
      </div>
      <div className="mb-3 sm:mb-4 lg:mb-5">
        <div className="flex gap-1.5 sm:gap-2">
          <SmallCheckbox
            id="authorizedByCustomer"
            className="size-3 sm:size-3.5 lg:size-4 border-[#D5D7DA] shadow-none mt-0.5"
          />
          <div className="space-y-0.5">
            <Label
              htmlFor="authorizedByCustomer"
              className="w-fit text-black text-xs sm:text-[0.825rem] lg:text-sm font-medium leading-4 sm:leading-5 mb-0 cursor-pointer"
            >
              Authorized by Customer
            </Label>
            <p className="text-black text-xs sm:text-[0.8125rem] font-normal leading-4 sm:leading-5">
              Please note that this call is being recorded for quality assurance
              and security purposes. By continuing, you confirm that you are the
              account holder or have full authorization to make changes and
              request sensitive information related to this account. You also
              acknowledge that you've reviewed and agreed to our Terms and
              Conditions and Privacy Policy. This recording may be used to
              resolve any disputes related to this request. Do you confirm and
              agree to proceed? Please say yes or no.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
